module.exports = __webpack_public_path__ + "static/media/captura-de-pantalla-2012-07-02-a-las-18-57-21.790a2355.png";